<template>
  <div>
    <el-card class="searchCon">
      <el-form label-position="top" size="small">
        <el-row :gutter="10">
          <el-col :span="6">
            <!-- 客户编码 -->
            <el-form-item :label="$t('mdfeTranslate.CustomerCode')">
              <el-select
                v-model="queryForm.params.customerId"
                :placeholder="$t('basicData.PleaseSelect')"
                style="width: 100%;"
                filterable
                clearable
                remote
                reserve-keyword
                :remote-method="getCustomerOption"
                @visible-change="getCustomerOptionDialog"
              >
                <el-option
                  v-for="item in customerOption"
                  :key="item.id"
                  :label="item.username + '（' + item.id + '）'"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 创建人 -->
            <el-form-item :label="$t('collectionCenter.creator')">
              <el-select
                v-model.trim="queryForm.params.createUser"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                :remote-method="getUserList"
                clearable
                filterable
                remote
                reserve-keyword
                style="width: 100%"
                @visible-change="getUserListDialog"
              >
                <el-option
                  v-for="item in userList"
                  :key="item.id"
                  :label="item.createUserName+'('+item.username+')'"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 开票CNPJ -->
            <el-form-item :label="$t('mdfeTranslate.InvoiceCNPJ')">
              <el-input v-model="queryForm.params.invoiceCnpj" :placeholder="$t('collectionCenter.pleaseInput')" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 开票IE -->
            <el-form-item :label="$t('mdfeTranslate.InvoiceIE')">
              <el-input v-model="queryForm.params.invoiceIe" :placeholder="$t('collectionCenter.pleaseInput')" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 操作类型 -->
            <el-form-item :label="$t('collectionCenter.operationType')">
              <el-select
                v-model="queryForm.params.operationType"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                style="width: 100%"
                clearable
              >
                <!-- 新增 -->
                <el-option :label="$t('collectionCenter.add')" :value="1" />
                <!-- 编辑 -->
                <el-option :label="$t('collectionCenter.edit')" :value="2" />
                <!--启用-->
                <el-option :label="$t('collectionCenter.enable')" :value="3" />
                <!-- 禁用 -->
                <el-option :label="$t('collectionCenter.disable')" :value="4" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <!-- 操作时间 -->
            <el-form-item :label="$t('operationCenter.operationTime')">
              <el-date-picker
                v-model="queryForm.params.invoiceIssueTime"
                type="datetimerange"
                range-separator="-"
                :picker-options="pickerOptions"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                :start-placeholder="$t('GlobalSetObj.startDate')"
                :end-placeholder="$t('GlobalSetObj.endDate')"
                style="width: 100%;"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <div style="margin-top: 10px;">
          <!--查询-->
          <el-button
            type="primary"
            icon="el-icon-search"
            size="mini"
            @click="search"
          >{{ $t('basicData.Search') }}
          </el-button>
          <!--重置-->
          <el-button
            icon="el-icon-refresh"
            size="mini"
            @click="onReset"
          >{{ $t('basicData.reset') }}
          </el-button>
          <!-- 导出 -->
          <el-button
            v-permit:remove="'btn:invoiceCenter:invoiceInformationOperationLog-onExport'"
            size="mini" type="primary" @click="onExport"
          >{{ $t('CenterForSorting.export') }}</el-button>
        </div>
      </el-form>
    </el-card>
    <el-card>
      <el-table
        :data="tableData"
        border
        class="table-height"
        :header-cell-style="{background:'#f2f2f2',color:'black'}"
        :height="tableHeightRow.height"
      >
        <el-table-column
          :label="$t('GlobalSetObj.serial')"
          align="center"
          type="index"
          width="80"
          fixed="left"
        />
        <el-table-column
          v-for="item in tableHeaderList"
          :key="item.prop"
          :align="item.align"
          :label="item.label"
          :min-width="item.minWidth"
          :prop="item.prop"
          :show-overflow-tooltip="item.tooltip"
        >
          <template slot-scope="scope">
            <div v-if="item.prop === 'operator'">
              <div>{{ createUser[scope.row.operator] }}</div>
            </div>
            <div v-else-if="item.prop === 'requestParams'">
              <el-tooltip placement="top">
                <pre slot="content" style="max-height: 400px; overflow: auto">
                  {{ scope.row.requestParamsNew }}
                </pre>
                <div class="paramsStyle">{{ scope.row[item.prop] }}</div>
              </el-tooltip>
            </div>
            <div v-else-if="item.prop === 'changeField'">
              <div v-for="(list, inde) in scope.row.changedFields" :key="inde">{{ list.field || '--' }}</div>
            </div>
            <div v-else-if="item.prop === 'oldValue'">
              <div v-for="(list, inde) in scope.row.changedFields" :key="inde">
                <div v-if="list.field === $t('collectionCenter.stateZT')">
                  <div v-if="list.oldValue == 1">{{ $t('collectionCenter.enable') }}</div>
                  <div v-else-if="list.oldValue == 0">{{ $t('collectionCenter.disable') }}</div>
                  <div v-else>--</div>
                </div>
                <div v-else>{{ list.oldValue || '--' }}</div>
              </div>
            </div>
            <div v-else-if="item.prop === 'newValue'">
              <div v-for="(list, inde) in scope.row.changedFields" :key="inde">
                <div v-if="list.field === $t('collectionCenter.stateZT')">
                  <div v-if="list.newValue == 1">{{ $t('collectionCenter.enable') }}</div>
                  <div v-else-if="list.newValue == 0">{{ $t('collectionCenter.disable') }}</div>
                  <div v-else>--</div>
                </div>
                <div v-else>{{ list.newValue || '--' }}</div>
              </div>
            </div>
            <div v-else>
              {{ scope.row[item.prop] }}
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页工具 -->
      <div class="pagination">
        <el-pagination
          :current-page.sync="queryForm.pageNumber"
          :page-size.sync="queryForm.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="margin: 10px 0"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import estimateTableHeight from '@/views/finance/mixins/estimateTableHeight';
import { getUserPage } from '@/api/user';
import { apiGetCustomerPage } from '@/api/finance/contasDeClientes';
import { getInvoiceSubjectLogPage, exportInvoiceSubjectLog } from '@/api/invoiceCenter';
import { goResourceTaskList } from '@/utils/goExportList';
const startTime = dayjs().format('YYYY-MM-DD') + ' 00:00:00';
const endTime = dayjs().format('YYYY-MM-DD') + ' 23:59:59'; // 设置此刻的时间
export default {
  name: 'InvoiceInformationOperationLog',
  mixins: [estimateTableHeight],
  data() {
    return {
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        params: {
          customerId: null,
          createUser: null,
          invoiceCnpj: null,
          invoiceIe: null,
          operationType: null,
          invoiceIssueTime: [startTime, endTime]
        }
      },
      pickerMinDate: '',
      pickerRange: 14 * 24 * 60 * 60 * 1000, // 可选择日期范围 为15天
      pickerOptions: {
        // 设置不能选择的日期
        onPick: ({ minDate }) => {
          if (minDate && this.pickerMinDate) {
            this.pickerMinDate = null;
          } else if (minDate) {
            this.pickerMinDate = minDate.getTime();
          }
        },
        disabledDate: (time) => {
          if (this.pickerMinDate) {
            return (time.getTime() > (this.pickerMinDate + this.pickerRange)) || (time.getTime() < (this.pickerMinDate - this.pickerRange));
          }
          return false;
        }
      },
      userList: [],
      tableData: [],
      tableHeaderList: [
        // 操作类型
        { label: this.$t('collectionCenter.operationType'), prop: 'operationType', minWidth: 180, align: 'center', tooltip: true },
        // 状态
        { label: this.$t('collectionCenter.stateZT'), prop: 'operationStatus', minWidth: 180, align: 'center', tooltip: true },
        // '客户编码'
        { label: this.$t('mdfeTranslate.CustomerCode'), prop: 'customerId', minWidth: 180, align: 'center', tooltip: true },
        // 请求参数
        { label: this.$t('mdfeTranslate.RequestParameters'), prop: 'requestParams', minWidth: 200, align: 'center', tooltip: false },
        // 响应参数
        // { label: this.$t('mdfeTranslate.ResponseParameters'), prop: 'responseData', minWidth: 200, align: 'center', tooltip: false },
        // 操作人账号
        { label: this.$t('mdfeTranslate.OperatorAccount'), prop: 'userName', minWidth: 180, align: 'center', tooltip: true },
        // 操作人
        { label: this.$t('collectionCenter.operator'), prop: 'realName', minWidth: 180, align: 'center', tooltip: true },
        // 操作时间
        { label: this.$t('operationCenter.operationTime'), prop: 'operateTime', minWidth: 180, align: 'center', tooltip: true },
        // 变更字段
        { label: this.$t('mdfeTranslate.ChangeField'), prop: 'changeField', minWidth: 180, align: 'center', tooltip: true },
        // 旧值
        { label: this.$t('mdfeTranslate.OldValue'), prop: 'oldValue', minWidth: 180, align: 'center', tooltip: true },
        // 新值
        { label: this.$t('mdfeTranslate.NewValue'), prop: 'newValue', minWidth: 180, align: 'center', tooltip: true }
      ],
      total: 0,
      customerOption: [],
      fieldsKey: {
        customerId: this.$t('mdfeTranslate.CustomerCode'),
        invoiceCnpj: this.$t('mdfeTranslate.InvoiceCNPJ'), // 发票CNPJ
        invoiceIe: this.$t('mdfeTranslate.InvoiceIE'), // 发票IE
        companyShortName: this.$t('mdfeTranslate.CompanyAbbreviation'), // 公司简称
        customerName: this.$t('customerManagements.AccountName'), // 账号名称
        companyFullName: this.$t('mdfeTranslate.CompanyFullName'), // 公司全称
        postalCode: this.$t('basicData.zipCode'), // 邮编
        uf: this.$t('mdfeTranslate.StateAbbreviationUF'), // 省份
        city: this.$t('collectionCenter.city'), // 城市
        street: this.$t('mdfeTranslate.Street'), // 街道
        detailedAddress: this.$t('placeOrder.detailedAddress'), // 详细地址
        supplementaryAddress: this.$t('mdfeTranslate.SupplementalAddress'), // 补充地址
        houseNumber: this.$t('placeOrder.HouseNumber'), // 门牌号
        cityCode: this.$t('mdfeTranslate.IBGECode'), // 城市代码
        phoneNumber: this.$t('orderCenterCont.telephoneNumber'), // 联系电话
        email: this.$t('orderDetails.email'), // 邮箱
        effectiveDate: this.$t('customerManagements.genterTiem'), // 生效时间
        expirationDate: this.$t('seller.expirationTime'), // 失效时间
        status: this.$t('collectionCenter.stateZT') // 状态
      }
    };
  },
  created() {
    this.getUserList();
    this.getCustomerOption();
    this.search();
  },
  methods: {
    // 客户选项弹窗打开
    getCustomerOptionDialog(val) {
      if (val) {
        this.getCustomerOption();
      }
    },
    // 获取客户选项
    getCustomerOption(name = '') {
      const param = {
        pageSize: 20,
        pageNumber: 1,
        params: {
          userNameOrId: name
        }
      };
      apiGetCustomerPage(param).then(res => {
        if (res.code === 200) {
          this.customerOption = res.data.records;
        }
      });
    },
    // 获取用户列表
    getUserList(usernameLike = '') {
      const param = {
        pageNumber: 1,
        pageSize: 10,
        params: {
          accountState: '1',
          usernameLike
        }
      };
      getUserPage(param, false).then((res) => {
        if (res.code === 200) {
          this.userList = res.data.records;
        }
      });
    },
    // 创建人选项弹窗打开
    getUserListDialog(val) {
      if (val) {
        this.getUserList();
      }
    },
    // 查询条件整理
    queryParam() {
      const { customerId, createUser, invoiceCnpj, invoiceIe, operationType, invoiceIssueTime } = this.queryForm.params;
      const params = {
        customerId: customerId !== null && customerId !== undefined && customerId !== '' ? customerId : null,
        createUser: createUser !== null && createUser !== undefined && createUser !== '' ? createUser : null,
        invoiceCnpj: invoiceCnpj !== null && invoiceCnpj !== undefined && invoiceCnpj !== '' ? invoiceCnpj : null,
        invoiceIe: invoiceIe !== null && invoiceIe !== undefined && invoiceIe !== '' ? invoiceIe : null,
        operationType: operationType !== null && operationType !== undefined && operationType !== '' ? operationType : null,
        startTime: null,
        endTime: null
      };
      if (Array.isArray(invoiceIssueTime) && invoiceIssueTime.length === 2) {
        params.startTime = invoiceIssueTime[0];
        params.endTime = invoiceIssueTime[1];
      }
      return params;
    },
    // 获取列表数据
    getTableData() {
      const queryParam = {
        pageSize: this.queryForm.pageSize,
        pageNumber: this.queryForm.pageNumber,
        params: this.queryParam()
      };
      console.log(queryParam, '===queryParam');
      getInvoiceSubjectLogPage(queryParam).then(res => {
        if (res.code === 200) {
          this.total = res.data.total;
          res.data.records.map(item => {
            if (item.requestParams) {
              item.requestParamsNew = JSON.stringify(JSON.parse(item.requestParams), null, 2);
            }
            if (item.changedFields) {
              const changedFields = JSON.parse(item.changedFields);
              const keys = Object.keys(changedFields);
              item.changedFields = keys.map(key => {
                const obj = {};
                obj.field = this.fieldsKey[key];
                obj.oldValue = changedFields[key].first === null || changedFields[key].first === undefined ? '' : changedFields[key].first;
                obj.newValue = changedFields[key].second === null || changedFields[key].second === undefined ? '' : changedFields[key].second;
                return obj;
              });
            }
          });
          this.tableData = res.data.records;
          console.log(this.tableData, '====this.tableData');
        }
      });
    },
    // 搜索
    search() {
      this.queryForm.pageNumber = 1;
      this.getTableData();
    },
    // 重置
    onReset() {
      this.queryForm.params = {
        customerId: null,
        createUser: null,
        invoiceCnpj: null,
        invoiceIe: null,
        operationType: null,
        invoiceIssueTime: [startTime, endTime]
      };
      this.getTableData();
    },
    // 导出
    onExport() {
      const queryParam = {
        pageSize: this.queryForm.pageSize,
        pageNumber: this.queryForm.pageNumber,
        params: this.queryParam()
      };
      exportInvoiceSubjectLog(queryParam).then(res => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    },
    // 每页显示数量改变时触发
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.getTableData();
    },
    // 当前页码改变时触发
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.getTableData();
    }
  }
};
</script>

<style>
.numberSearch .el-input--small .el-input__inner {
  line-height: 28px;
  height: 28px;
  border: none;
  padding-left: 0;
  font-weight: bold;
}
.searchCon .el-form-item {
  margin-bottom: 0 !important;
}
.paramsStyle {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
